import {SelectOption} from "../../../../components/SimpleSelect";

export const alignments: SelectOption[] = [{
  id: "left",
  name: "Left"
}, {
  id: "center",
  name: "Center"
}, {
  id: "right",
  name: "Right"
}]